export default {
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    backgroundColor: (theme) => theme.palette.grays.lightBackgroundGray,
    borderBottom: (theme) =>
      `1px solid ${theme.palette.grays.lightBackgroundGray}`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays.gray100,
    },
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: (theme) => theme.palette.grays.gray900,
  },
  buttonGroup: {
    display: 'flex',
    gap: '8px',
  },
  sectionContainer: {
    padding: '10px 0',
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: '0',
    },
  },
  subsectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: (theme) => theme.palette.grays.gray900,
    marginBottom: '16px',
  },
  formGrid: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  checkboxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, minmax(200px, 1fr))',
    gap: '12px',
    width: '100%',

    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(2, minmax(200px, 1fr))',
    },
    '@media (min-width: 1200px)': {
      gridTemplateColumns: 'repeat(3, minmax(200px, 1fr))',
    },
  },
  modernCheckbox: {
    color: (theme) => theme.palette.blues.primaryBlue500,
    '&.Mui-checked': {
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '&.Mui-disabled': {
      color: (theme) => theme.palette.grays.gray300,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
  },
  checkboxLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      color: (theme) => theme.palette.grays.gray900,
      fontWeight: '400',
    },
    '&.Mui-disabled .MuiFormControlLabel-label': {
      color: (theme) => theme.palette.grays.gray400,
    },
  },
  loadingWrapper: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    inset: 0,
    backgroundColor: (theme) => theme.palette.grays.lightestGray,
    zIndex: 1000,
  },
  textFieldWrapper: {
    mb: 1,
    width: '300px',
  },
  checkboxFieldWrapper: {
    mb: 1,
    width: '250px',
  },
  chevronButton: {
    padding: '4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};
